//jQuery.noConflict();     
$(document).ready(function() {
 
  // Mobile menu
  $('#mobile-menu').on('click', function() {
    let $body = $('body');
    let $mobileMenu = $('.shifter-navigation');
    if ($body.hasClass('shifter-open')) {
      $body.removeClass('shifter-open');
    } else {
      $body.addClass('shifter-open');
      $mobileMenu.removeClass('hide');
    }
  });
 
  $('#page-container .overlay').on('click', function() {
    let $mobileMenu = $('.shifter-navigation');
    $('body').removeClass('shifter-open');
    setTimeout(function() {
      $mobileMenu.addClass('hide');
    }, 400);
  });
 
  $('.accordion-toggle').on('click', function() {
    //Expand or collapse this panel
    $(this).next().slideToggle('fast');
    //Hide the other panels
    $(".accordion-content").not($(this).next()).slideUp('fast');
  });
 
  // Call Fancybox globally on all elements with class fancybox
  $(".fancybox").fancybox({
    helpers: {
      overlay: {
        locked: false
      }
    }
  });

      // custom sort functions
    function compare_a_z(a, b){
      var compA = $(a).data('alpha');
      var compB = $(b).data('alpha');
      return (compA < compB) ? -1 : (compA > compB ) ? 1 : 0;
    }
    
    function compare_z_a(a, b){
      var compA = $(a).data('alpha');
      var compB = $(b).data('alpha');
      return (compA > compB) ? -1 : (compA < compB ) ? 1 : 0;
    }
    
    function compare_l_h(a, b){
      var compA = $(a).data('price');
      var compB = $(b).data('price');
      return (compA < compB) ? -1 : (compA > compB ) ? 1 : 0;
    }
    
    function compare_h_l(a, b){
      var compA = $(a).data('price');
      var compB = $(b).data('price');
      return (compA > compB) ? -1 : (compA < compB ) ? 1 : 0;
    }
    
    
    // vertical alignment of images
    
    // Lazy Loading of images on collectin page    
    function setLazy(){
      $('.lazy').lazyload({
      effect: "fadeIn",
            threshold: 200
        });
setTimeout(function () {
  window.scrollTo(0, 1);
}, 500);
    }
 
    // call Lazy Load initially
    setLazy();
    
  // verticalAlignImages();
        
    // on sortBox change collect the products
    $('select#sortBox').change(function(){
      arr = [];
      sort_func = $(this).children(':selected').val();

      $('li.collectionitem').each(function(){
      arr.push(this);
    });
    // find which sort was selected and run the right sort function
    if (sort_func == "a_z"){
      arr.sort(compare_a_z);
    }
    else if (sort_func == "z_a"){
      arr.sort(compare_z_a);
    }
    if (sort_func == "l_h"){
      arr.sort(compare_l_h);
    }
    else if (sort_func == "h_l"){
      arr.sort(compare_h_l);
    }
    // push the arranged products back out
    $('#four-column-collectionlist').append(arr);

    // push the arranged products back out
    $('#three-column-collectionlist').append(arr);
    
    // push the arranged products back out
    $('#two-column-collectionlist').append(arr);
    
    // reset Lazy Loading just in case images sorted to top fail to show
    setLazy();
    });
    
});